import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Card from 'components/Card';
import ProgressBar from 'components/ProgressBar';
import Title from 'components/Title';
import './style.scss';

const steps = [{ title: __('Identity Verification') }, { title: __('Change Password') }, { title: __('Done') }];

// 忘记密码
const Password: React.FC = () => {
    const { pathname } = useLocation();
    const selectedIndex = useMemo(() => {
        const step = pathname.match('/(verify|reset|success)')?.[1];

        return { verify: 1, reset: 2, success: 3 }[step || 'verify'] || 1;
    }, [pathname]);

    return (
        <Card page className="account-password-page">
            <Title title={__('Reset Password')} />
            <h2 className="text-center">{__('Reset Password')}</h2>
            <ProgressBar steps={steps} selectedIndex={selectedIndex} className="mt-5" />
            <Outlet />
        </Card>
    );
};

export default Password;
